import React from 'react';

export const Logo = ({ className = '' }) => (
  <div className={`flex items-center ${className}`}>
    <img src="/brand/refocc-logo.png" alt="REFOCC Logo" className="h-16 w-auto object-contain" />
  </div>
);

export default Logo;
